import { render } from "./page-calendar.vue?vue&type=template&id=d3ef9514"
import script from "./page-calendar.vue?vue&type=script&lang=js"
export * from "./page-calendar.vue?vue&type=script&lang=js"

import "./page-calendar.vue?vue&type=style&index=0&id=d3ef9514&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__